export default __webpack_public_path__ + "static/blob8-ef36b82bd5ab490b3e861350d465f9d5.svg";